import React from 'react';
import { NavLink, Routes, Route, Navigate } from 'react-router-dom';
import { FiFileText, FiBarChart2, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import Navbar from '../Navbar';
import Footer from '../Footer';
import MonthlyVATPayment from './MonthlyVATPayment/MonthlyVATPayment';
import TrialBalanceUpload from './TrialBalance/TrialBalanceUpload';
import { useAccountingSidebar } from '../../context/AccountingSidebarContext';

const menuItems = [
    { path: 'monthly-vat', label: 'Monthly VAT', icon: FiFileText },
    { path: 'trial-balance', label: 'Trial Balance', icon: FiBarChart2 },
];

const AccountingLayout = () => {
    const { collapsed, toggleCollapsed } = useAccountingSidebar();

    return (
        <div className="flex flex-col min-h-screen">
            <Navbar />

            <div className="flex flex-1">
                <aside
                    className={`${collapsed ? 'w-14' : 'w-56'
                        } bg-gray-100 border-r border-gray-200 p-2.5 transition-all duration-200 flex flex-col sticky top-0 max-h-[calc(100dvh-50px)] overflow-y-auto shrink-0`}
                >
                    <button
                        onClick={toggleCollapsed}
                        className="self-end mb-3 p-2 rounded-md text-gray-500 hover:bg-gray-200 hover:text-gray-700 transition-colors"
                        title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
                    >
                        {collapsed ? (
                            <FiChevronRight size={16} />
                        ) : (
                            <FiChevronLeft size={16} />
                        )}
                    </button>

                    <nav className="flex flex-col gap-1">
                        {menuItems.map((item) => {
                            const Icon = item.icon;

                            return (
                                <NavLink
                                    key={item.path}
                                    to={item.path}
                                    title={collapsed ? item.label : undefined}
                                    className={({ isActive }) =>
                                        `no-underline flex items-center gap-3 px-3 py-2 rounded-md transition-colors ${collapsed ? 'justify-center' : ''
                                        } ${isActive
                                            ? 'bg-blue-600 text-white'
                                            : 'text-gray-700 hover:bg-gray-200'
                                        }`
                                    }
                                >
                                    <Icon size={16} className="shrink-0" />
                                    {!collapsed && (
                                        <span className="whitespace-nowrap text-sm font-semibold">
                                            {item.label}
                                        </span>
                                    )}
                                </NavLink>
                            );
                        })}
                    </nav>
                </aside>

                <main className="flex-1 p-3">
                    <Routes>
                        <Route
                            index
                            element={<Navigate to="monthly-vat" replace />}
                        />
                        <Route
                            path="monthly-vat"
                            element={<MonthlyVATPayment />}
                        />
                        <Route
                            path="trial-balance"
                            element={<TrialBalanceUpload />}
                        />
                    </Routes>
                </main>
            </div>

            <Footer />
        </div>
    );
};

export default AccountingLayout;